module.exports = __webpack_public_path__ + "static/media/add award.df4f9142.svg";